import * as $ from 'jquery';
import 'bootstrap';

export default (function () {
    $('#dialog-user-delete,#dialog-user-deactivate,#dialog-user-activate').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        button.tooltip('hide');
        var url = button.data('url');
        var modal = $(this);
        modal.find('form').attr('action', url);
    });

    if ($('.user-form').length) {

        var $changePasswordCheck = $('#changePassword');
        if ($changePasswordCheck.val() == 1) {
            var $wrapper = $('.user-form .change-password');
            $wrapper.addClass('change');
            $wrapper.find('.change-password-inputs input').each(function(index, el) {
                $(el).attr('required', 'required');
            })
        }

        $('.user-form #changePassButton').on('click', function(event) {
            $changePasswordCheck.val(1);
            var $wrapper = $(this).closest('.change-password');
            $wrapper.addClass('change');
            $wrapper.find('.change-password-inputs input').each(function(index, el) {
                $(el).attr('required', 'required');
            })
        });

        $('.user-form #cancelChangePassButton').on('click', function(event) {
            $changePasswordCheck.val(0);
            var $wrapper = $(this).closest('.change-password');
            $wrapper.find('input[type=password]').val('');
            $wrapper.removeClass('change');
            $wrapper.find('.change-password-inputs input').each(function(index, el) {
                $(el).attr('required', false);
            })
        });
    }
}());
